import React, { useEffect, useMemo } from "react"
import '@grapecity/wijmo.styles/wijmo.css';
import * as wjGrid from '@grapecity/wijmo.react.grid';
import * as wijmo from '@grapecity/wijmo';
import '@grapecity/wijmo.cultures/wijmo.culture.ja';
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { CollectionViewNavigator } from "@grapecity/wijmo.react.input";
import { CellMaker } from "@grapecity/wijmo.grid.cellmaker";
import '../../../static/css/QAListResult.css'
import { CollectionView } from '@grapecity/wijmo';
import { useGlobalState } from "../../../provider/Provider";
import { getSessionStorageCon, isSessionStorageCon } from "../../../User";

interface Prop {
  pageSize: number,
  handleClickKeiyakuno: (num: string) => void
}

const ContractListResult: React.FC<Prop> = (props) => {
  const { pageSize, handleClickKeiyakuno } = props
  const { backpage } = useGlobalState('page')
  const globalconlistState = useGlobalState('contractlist')
  const [data, setData] = React.useState<CollectionView<any> | string>('')
  const [open, setOpen] = React.useState<boolean>(false)
  const headerRef = React.useRef(null)

  useEffect(() => {
    let cleanup = false;
    if (globalconlistState.length === 0) {
      if (!cleanup) {
        setOpen(false)
        setData('該当する契約情報はありません')
      }
    } else {
      if (!cleanup) {
        const setDataPage = (): CollectionView<any> => {
          return new CollectionView(globalconlistState, {
            pageSize: pageSize,
          })
        }
        setOpen(true)
        setData(setDataPage())
      }
    }
    return () => { cleanup = true }
  }, [globalconlistState])

  useEffect(() => {
    if (data && typeof data !== 'string' && backpage && isSessionStorageCon()) {
      const [pageindex, pagesort] = getSessionStorageCon()
      if (pagesort && typeof (pagesort.ascending) === 'boolean' && pagesort.property) {
        data.sortDescriptions.push(new wijmo.SortDescription(pagesort.property, pagesort.ascending))
      }
      data.moveToPage(pageindex)
    }
  }, [data, backpage, isSessionStorageCon()])


  const transContractInfo = (ctx: any, event: any) => {//ctx: ICellTemplateContext
    //contractListResult param stored sessionstorage
    try {
      if (headerRef && headerRef.current) {
        const conresult = {
          //@ts-ignore
          pageindex: headerRef?.current?.props.cv.pageIndex,
          pagesort: {
            //@ts-ignore
            property: headerRef?.current?.props.cv.sortDescriptions.length === 0 ? undefined : headerRef?.current?.props.cv.sortDescriptions[0].property,
            //@ts-ignore
            ascending: headerRef?.current?.props.cv.sortDescriptions.length === 0 ? undefined : headerRef?.current?.props.cv.sortDescriptions[0].ascending
          },
        }
        const setstr = unescape(encodeURIComponent(JSON.stringify(conresult)))
        sessionStorage.setItem('SESSIONCON', btoa(setstr));
      }
    } catch (err) {
      if (err.message.match(/exceeded the quota/)) {
        console.log('Session Storage is full')
      } else { console.log(err) }
    }
    if (ctx.value) {
      handleClickKeiyakuno(ctx.value)
    }
  }

  const handleResult = useMemo((): JSX.Element => {
    if (open) {
      return <React.Fragment>
        <CollectionViewNavigator headerFormat="{current:n0} / {count:n0} ページ" byPage={true} cv={data} ref={headerRef} />
        <wjGrid.FlexGrid itemsSource={data} autoRowHeights={true} selectionMode="None" isReadOnly={true} >
          <FlexGridFilter />
          <wjGrid.FlexGridColumn header="契約番号" binding="keiyakuNo" wordWrap={true} width="*" minWidth={110} cellTemplate={CellMaker.makeButton({
            click: (event: any, ctx) => transContractInfo(ctx, event)
          })} />
          <wjGrid.FlexGridColumn header="顧客名" binding="customerName" isReadOnly={true} width="3*" minWidth={50} wordWrap={true} allowResizing={false} />
          <wjGrid.FlexGridColumn header="契約項目" binding="keiyakuClsName" isReadOnly={true} width="3*" minWidth={50} wordWrap={true} allowResizing={false} />
          <wjGrid.FlexGridColumn header="契約開始日" binding="keiyakuStartTs" isReadOnly={true} width="*" minWidth={50} wordWrap={true} />
          <wjGrid.FlexGridColumn header="解約日" binding="kaiyakuTs" isReadOnly={true} wordWrap={true} width="*" minWidth={50} />
          <wjGrid.FlexGridColumn header="更新月" binding="renewalMonth" isReadOnly={true} wordWrap={true} width="*" minWidth={50} />
        </wjGrid.FlexGrid>
      </React.Fragment>
    } else {
      return <Typography variant="h6" align='center'>{data}</Typography>
    }
  }, [data, open])

  return (
    <React.Fragment>
      <Card style={{ maxHeight: '80vh' }}>
        <CardContent>
          {handleResult}
        </CardContent>
      </Card>
    </React.Fragment>
  )
}

export default ContractListResult